
import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
  withText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ className, size = 32, withText = false }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-sm"
      >
        <path 
          d="M50 5 C30 5 15 20 15 40 C15 65 50 95 50 95 C50 95 85 65 85 40 C85 20 70 5 50 5 Z" 
          fill="#007AFF"
        />
        <path 
          d="M35 48 L50 33 L65 48 V63 H55 V53 H45 V63 H35 V48 Z" 
          fill="white"
        />
        <rect x="47" y="44" width="6" height="6" fill="white" fillOpacity="0.3" />
      </svg>
      {withText && (
        <span className="text-xl font-black tracking-tighter text-black dark:text-white">
          Findily
        </span>
      )}
    </div>
  );
};
